import "./styles/mobileapps.css";
import Nav from "./Nav";
import Footer from "./Footer";
// import { useState } from "react";
// import Alert from "@mui/material/Alert";
// import AlertTitle from "@mui/material/AlertTitle";
// import slush from "../images/icon/slushCupBlack.webp";
// import axios from "axios";

export default function Franchise() {
  return (
    <section class="franchise">
      <Nav />
      <div class="content">
        <h2>Get the Tubbees App Today!</h2>
        <p>
          Download our app and start enjoying exclusive deals, rewards, and
          more!
        </p>

        <div class="store-links">
          <a
            href="https://play.google.com/store/apps/details?id=com.tubbees"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/google-play-badge.png" alt="Get it on Google Play" />
          </a>
          <a
            href="https://apps.apple.com/gb/app/tubbees-loyalty/id6738990046"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/app-store-badge.svg" alt="Download on the App Store" />
          </a>
        </div>
      </div>

      <Footer />
    </section>
  );
}
